import React, { useEffect } from 'react'

interface TotalNumberInTableProps {
  number: number
}

const TotalNumberInTable: React.FC<TotalNumberInTableProps> = ({ number }) => {
  const numberWithCommas = (x: number): string => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }

  useEffect(() => {
    const formattedNumber = numberWithCommas(number)
    const element = document.getElementById(`number-${number}`)
    if (element) {
      element.innerHTML = `<span class="font-bold">Total:</span> ${formattedNumber}`
    }
  }, [number])

  return (
    <p id={`number-${number}`} className="">
      Total: {number}
    </p>
  )
}

export default TotalNumberInTable
